export default {
  FETCH_ALL_REQUEST: 'ROLES_FETCH_ALL_REQUEST',
  FETCH_ALL_SUCCESS: 'ROLES_FETCH_ALL_SUCCESS',
  FETCH_ALL_FAILURE: 'ROLES_FETCH_ALL_FAILURE'
}
